export interface CartItemPriceSelectionInput {
  price?: number
  memberPrice?: number
}

/**
 * Leaf module: cartPanelUtils.ts and tripListPrices.ts both need this, and
 * tripListPrices.ts already imports computeCartPanelTotal from
 * cartPanelUtils.ts, so this logic cannot live in either of those two files
 * without creating an import cycle.
 */
export function getValidCartItemMemberPrice(item: CartItemPriceSelectionInput): number | undefined {
  if (item.price === undefined) return undefined
  if (item.memberPrice === undefined) return undefined
  if (item.memberPrice <= 0) return undefined
  if (item.memberPrice >= item.price) return undefined
  return item.memberPrice
}

export function getCartItemDisplayPrice(item: CartItemPriceSelectionInput, useMemberPrice: boolean): number | undefined {
  if (useMemberPrice) {
    const memberPrice = getValidCartItemMemberPrice(item)
    if (memberPrice !== undefined) return memberPrice

    // getValidCartItemMemberPrice requires a base price to confirm memberPrice is a genuine
    // discount, so it can't tell "no price at all" apart from "a defined but non-discount
    // member price" -- both return undefined here. When there's no base price to fall back
    // to, a positive memberPrice is still the only real number known for this item; drop it
    // silently instead and the item vanishes from the total it should still count toward.
    if (item.price === undefined && item.memberPrice !== undefined && item.memberPrice > 0) {
      return item.memberPrice
    }
  }

  return item.price
}
